// test1980
(1980 && 0);
